/**
 * Meta (Facebook) Pixel events for the marketing site.
 *
 * The base pixel and the global fbq() are installed by
 * templates/_partials/meta-pixel.twig from site.metaPixelId, under the SAME pixel
 * ID as app.fusca.co.nz and the Flask preview tool, so events from all three
 * aggregate into one dataset.
 *
 * WHY THIS FILE EXISTS
 * The hero price check used to hand the visitor to app.fusca.co.nz, where the
 * Flask tool fired Search, Lead and the CTA events itself. Now that the result
 * renders natively here, those events have to be fired here or the funnel simply
 * stops reporting from its first step.
 *
 * KEEPING PARITY
 * The names and parameter shapes below mirror templates/preview.html in the
 * fusca_pro_lookup repo, and app/resources/js/pixel.js in the Laravel app. These
 * now exist in more than one codebase and CAN drift. If you change an event here,
 * change it there, or the two halves of the same funnel stop being comparable in
 * Events Manager.
 *
 * Flask fires: Search, Lead (with email advanced matching), and the custom
 * ClipValueCalculated, PreviewCtaViewed, PreviewCtaClick, PreviewCtaClickUngated.
 * ClipValueCalculated is absent here on purpose: there is no clip calculator in
 * the hero panel.
 *
 * Every call no-ops when fbq is missing, which also covers ad blockers. Analytics
 * must never break the page it is measuring.
 */

/* ?nofbq=1 suppresses everything, matching the escape hatch the Flask tool and the
 * Laravel wrapper already honour, so an admin demoing the page does not write into
 * the live dataset. */
function suppressed() {
    try {
        return new URLSearchParams(window.location.search).has('nofbq');
    } catch (e) {
        return false;
    }
}

function fbq(...args) {
    if (typeof window === 'undefined' || typeof window.fbq !== 'function' || suppressed()) {
        return;
    }

    try {
        window.fbq(...args);
    } catch (e) {
        /* Never let a tracking failure surface to the visitor. */
    }
}

/** Standard event: a price lookup ran. */
export function trackSearch(micron) {
    fbq('track', 'Search', {
        search_string: String(micron),
        content_category: 'wool_price_lookup',
        micron: micron,
    });
}

/**
 * Standard event: an email was captured.
 *
 * Re-inits the pixel with the email so Meta can hash and match it, which is what
 * lifts Event Match Quality. The address is read from the field at runtime and is
 * never rendered into the page source.
 */
export function trackLead(email, micron) {
    const pixelId = document.querySelector('meta[name="meta-pixel-id"]')?.content;

    if (pixelId && email) {
        fbq('init', pixelId, { em: email });
    }

    fbq('track', 'Lead', {
        content_name: 'weekly_micron_email',
        content_category: 'wool_price_lookup',
        micron: micron,
        location: 'cms_hero',
    });
}

/** Custom: the result panel, and the call to action inside it, came into view. */
export function trackCtaViewed(micron) {
    fbq('trackCustom', 'PreviewCtaViewed', { micron: micron, location: 'cms_hero' });
}

/** Custom: the visitor clicked through to the app from the result panel. */
export function trackCtaClick(micron, location) {
    fbq('trackCustom', 'PreviewCtaClick', { micron: micron, location: location || 'cms_hero' });
}
